import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './HomeSelector.css';
import Icon from './Icon';

const PREF_KEY = 'preferred_league';

export default function HomeSelector({ onSelect }) {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const pref = localStorage.getItem(PREF_KEY);
    if (pref === 'dynasty') {
      onSelect('dynasty');
    } else if (pref === 'lor') {
      navigate('/league-of-record');
    } else {
      setVisible(true);
    }
  }, [navigate, onSelect]);

  const pick = (league) => {
    localStorage.setItem(PREF_KEY, league);
    if (league === 'lor') {
      navigate('/league-of-record');
    } else {
      onSelect('dynasty');
    }
  };

  if (!visible) return null;

  return (
    <div className="home-selector-overlay">
      <div className="home-selector-inner">
        <div className="home-selector-header">
          <div className="home-selector-logo"><Icon emoji="⚡" size={24} /></div>
          <span className="home-selector-eyebrow">League Intelligence Platform</span>
          <h1 className="home-selector-title">LeagueIntel</h1>
          <p className="home-selector-sub">Select your command center</p>
        </div>

        <div className="home-selector-cards">
          <button className="league-card league-card--lor" onClick={() => pick('lor')}>
            <div className="league-card-icon"><Icon emoji="🏆" size={32} /></div>
            <div className="league-card-body">
              <span className="league-card-eyebrow">Flagship Redraft · Est. 2012</span>
              <div className="league-card-name">League of Record</div>
              <div className="league-card-sub">Weekly warfare. Keeper battles. 14 seasons of rivalry, history, and receipts.</div>
              <div className="league-card-metrics">
                <div className="card-metric">
                  <span className="card-metric-value">14</span>
                  <span className="card-metric-label">Seasons</span>
                </div>
                <div className="card-metric">
                  <span className="card-metric-value">10</span>
                  <span className="card-metric-label">Teams</span>
                </div>
                <div className="card-metric">
                  <span className="card-metric-value">Full PPR</span>
                  <span className="card-metric-label">Format</span>
                </div>
                <div className="card-metric">
                  <span className="card-metric-value">2</span>
                  <span className="card-metric-label">Keepers</span>
                </div>
              </div>
            </div>
            <div className="league-card-arrow">→</div>
          </button>

          <button className="league-card league-card--dynasty" onClick={() => pick('dynasty')}>
            <div className="league-card-icon"><Icon emoji="👑" size={32} /></div>
            <div className="league-card-body">
              <span className="league-card-eyebrow">Franchise Intelligence · Ongoing</span>
              <div className="league-card-name">Dynasty</div>
              <div className="league-card-sub">Long-horizon asset warfare. Legacy Board. Draft capital. Trade Lab.</div>
              <div className="league-card-metrics">
                <div className="card-metric">
                  <span className="card-metric-value">10</span>
                  <span className="card-metric-label">Teams</span>
                </div>
                <div className="card-metric">
                  <span className="card-metric-value">PPR</span>
                  <span className="card-metric-label">Scoring</span>
                </div>
                <div className="card-metric">
                  <span className="card-metric-value">SF</span>
                  <span className="card-metric-label">SuperFlex</span>
                </div>
                <div className="card-metric">
                  <span className="card-metric-value">Taxi</span>
                  <span className="card-metric-label">Dev Squad</span>
                </div>
              </div>
            </div>
            <div className="league-card-arrow">→</div>
          </button>
        </div>

        <p className="home-selector-footer">
          Your selection is remembered — switch anytime from the navigation bar.
        </p>
      </div>
    </div>
  );
}

export function LeagueSwitcher({ current }) {
  const navigate = useNavigate();

  const switchTo = (league) => {
    localStorage.setItem(PREF_KEY, league);
    if (league === 'lor') {
      navigate('/league-of-record');
    } else {
      navigate('/');
    }
  };

  if (current === 'dynasty') {
    return (
      <button
        className="league-switcher"
        onClick={() => switchTo('lor')}
        title="Switch to League of Record"
      >
        <Icon emoji="🏆" size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} /> League of Record
      </button>
    );
  }
  return (
    <button
      className="league-switcher"
      onClick={() => switchTo('dynasty')}
      title="Switch to Dynasty"
    >
      <Icon emoji="👑" size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} /> Dynasty
    </button>
  );
}
